import { render, staticRenderFns } from "./SelectFieldsStep.vue?vue&type=template&id=406be7b6&"
import script from "./SelectFieldsStep.vue?vue&type=script&lang=js&"
export * from "./SelectFieldsStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports